<div class="flex md:p-4 p-1 flex-col justify-start basis-full app-full-height">
  <h1 class="xl:flex hidden py-6">Your Workshop Jobs</h1>

  <div class="flex flex-row justify-start items-start w-full gap-x-2">
    <div
      class="flex flex-col justify-start items-stretch basis-full flex-shrink xl:flex"
      [class.hidden]="selectedId() !== null"
    >
      <table
        mat-table
        [dataSource]="jobs$ | async"
        class="hidden xl:table w-full"
      >
        <tr mat-header-row *matHeaderRowDef="lgColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: lgColumns"
          [style]="{
            'background-color': row.id === selectedId() ? '#f1fff1' : ''
          }"
        ></tr>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row">
            <a [routerLink]="['/workshop/job/', row.id]">{{ row.id }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="booked_in_date">
          <th mat-header-cell *matHeaderCellDef>Booked In</th>
          <td mat-cell *matCellDef="let row">
            {{ row.booked_in_at | date: 'short' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="customer">
          <th mat-header-cell *matHeaderCellDef>Customer</th>
          <td mat-cell *matCellDef="let row">
            @if (row.customer_name) {
              {{ row.customer_name }}
            } @else {
              <p class="italic">Internal</p>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="site_visit">
          <th mat-header-cell *matHeaderCellDef>Site visit</th>
          <td mat-cell *matCellDef="let row">
            @if (row.site_visit_date) {
              <div class="flex flex-row justify-start items-center gap-x-2">
                <p>
                  {{ row.site_visit_date | date: 'short' }} -
                  {{ row.site_visit_address }}
                </p>
                <app-google-maps-link
                  [placeId]="row.site_place_id"
                  [address]="row.site_visit_address"
                ></app-google-maps-link>
              </div>
            } @else {
              <p class="italic">No site visit scheduled</p>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="equipment">
          <th mat-header-cell *matHeaderCellDef>Equipment</th>
          <td mat-cell *matCellDef="let row">
            {{ row.job_name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            {{ row.work_status | workshopJobStatusLabel }}
          </td>
        </ng-container>
      </table>

      <table mat-table [dataSource]="jobs$ | async" class="xl:hidden w-full">
        <tr mat-header-row *matHeaderRowDef="smColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: smColumns"
          (click)="selectJob(row)"
        ></tr>
        <ng-container matColumnDef="compact">
          <th mat-header-cell *matHeaderCellDef>
            <h1>Your Workshop Jobs</h1>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="flex flex-col justify-start items-start w-full py-3">
              <h2>Workshop Job {{ row.id }}</h2>
              <p>
                <strong>Booked In: </strong>
                {{ row.booked_in_at | date: 'short' }}
              </p>
              <p>
                <strong>Customer: </strong>
                @if (row.customer_name) {
                  {{ row.customer_name }}
                } @else {
                  <p class="italic">Internal</p>
                }
              </p>
              <p>
                <strong>Site visit: </strong>
                @if (row.site_visit_date) {
                  {{ row.site_visit_date | date: 'short' }} -
                  {{ row.site_visit_address }}
                } @else {
                  <p class="italic">No site visit scheduled</p>
                }
              </p>
              <p>
                <strong>Equipment: </strong>
                {{ row.job_name }}
              </p>
              <p>
                <strong>Status: </strong>
                {{ row.work_status | workshopJobStatusLabel }}
              </p>
            </div>
          </td>
        </ng-container>
      </table>
    </div>
  </div>
</div>
